export const HOW_IT_WORKS = [
  {
    step: 1,
    title: 'Get your plan',
    description:
      'We’ve already set your profile! Just get your Pro Plan and download the App',
  },
  {
    step: 2,
    title: 'Explore characters',
    description:
      'Check collection made special for you, explore thousands of character or create your own AI',
  },
  {
    step: 3,
    title: 'Dive in pleasure',
    description:
      'Enjoy unlimited chats, exclusive content from your favorite characters and more...',
  },
];

export const HOW_IT_WORKS_OPEN_APP = [
  {
    step: 1,
    title: 'Get your plan',
    description:
      'We’ve already set your profile! Just get your Pro Plan and open the App',
  },
  ...HOW_IT_WORKS.slice(1),
];

export const HOW_IT_WORKS_WEB = [
  {
    step: 1,
    title: 'Get your plan',
    description: "We've already set your profile! Just get your Pro Plan",
  },
  {
    step: 2,
    title: 'Explore characters',
    description:
      'Check collection made special for you, explore thousands of character or create your own AI',
  },
  {
    step: 3,
    title: 'Dive in pleasure',
    description:
      'Enjoy unlimited chats, exclusive content from your favorite characters and more...',
  },
];

export const HOW_IT_WORKS_LURE_AI = [
  {
    step: 1,
    title: 'Get your plan',
    description:
      "We've already set your profile! Just get your Pro Plan and dive into AI world",
  },
  {
    step: 2,
    title: 'Explore characters',
    description:
      'Check collection made special for you, explore thousands of character or create your own AI',
  },
  {
    step: 3,
    title: 'Dive in pleasure',
    description:
      'Enjoy unlimited chats, exclusive content from your favorite characters and more...',
  },
];
